export function viewConstraintChange(oldViews, newViews, sizeChange) {
  if (!oldViews) return false;

  const changeLargeEnough = (v1, v2) =>
    v1 / v2 <= sizeChange || v1 / v2 >= 1.0 + sizeChange;

  return oldViews.some(oldView => {
    const newView = newViews.find(view => view.id === oldView.id);
    if (!newView) return false;

    const oldConstraint = oldView.constraint;
    const newConstraint = newView.constraint;
    return (
      changeLargeEnough(oldConstraint.width, newConstraint.width) ||
      changeLargeEnough(oldConstraint.height, newConstraint.height)
    );
  });
}
